import { render, staticRenderFns } from "./PreTargetDetail.vue?vue&type=template&id=db58de48&scoped=true"
import script from "./PreTargetDetail.vue?vue&type=script&lang=js"
export * from "./PreTargetDetail.vue?vue&type=script&lang=js"
import style0 from "./PreTargetDetail.vue?vue&type=style&index=0&id=db58de48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58de48",
  null
  
)

export default component.exports